<template>
  <div id="app">
    <div class="in">
      <div class="tip">
        <p>
          <marquee behavior="scroll">{{data.tips}}</marquee>
        </p>
      </div>
      <div class="header">
        <img :src="data.bg" alt="bg" />
        <div class="card mw">
          <div class="in flex">
            <div class="img">
              <img :src="data.logo" alt="logo" />
            </div>
            <div class="name">
              <div class="title">{{data.name}}</div>
              <div class="slogn">{{data.slogn}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty"></div>
      <div class="book-list flex mw">
        <a v-for="(item,index) in data.list" :key="index" class="card" :href="item.src">
          <img :src="item.img?item.img:item.src.replace('index.html', '')+'files/mobile/1.jpg'" alt />
          <p>{{item.name}}</p>
        </a>
      </div>
      <!-- <div class="footer">
        <div class="flex">
          <p>
            <a :href="'tel:'+data.phone">{{data.message}}</a>
          </p>
          <p>技术支持：鼎岳传媒</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        tips: null,
        name: null,
        slogn: null,
        message: null,
        list: null,
        bg: null,
        logo: null
      },
      timerInterval: null
    };
  },
  created() {
    this.$axios({
      method: "get",
      url: "./data.json"
    }).then(res => {
      this.data = res.data;
    });
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  width: 100%;
  background: #f1f1f1;
  img {
    max-width: 100%;
    display: block;
  }
  a {
    text-decoration: none;
    display: block;
  }
  .card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 6px 2px rgba($color: #d2d2d2, $alpha: 0.38);
    overflow: hidden;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .mw {
    width: 86%;
    margin: 0 auto;
  }
  .in {
    max-width: 500px;
    margin: 0 auto;
    overflow: auto;
    background: #fff;
    position: relative;
    .tip {
      position: absolute;
      top: 0;
      z-index: 1;
      background: rgba($color: #000, $alpha: 0.18);
      color: #fff;
      width: 100%;
      p {
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .header {
      position: relative;
      .card {
        box-shadow: 0 0 6px 2px rgba($color: #3f8bf6, $alpha: 0.18);
        position: absolute;
        bottom: -50px;
        left: 50%;
        margin-left: -43%;
        .in {
          padding: 5% 10%;
          justify-content: flex-start;
          flex-wrap: nowrap;
          .img {
            width: 25%;
            margin-right: 5%;
          }
          .name {
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            .title {
              font-size: 16px;
              font-weight: bold;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .slogn {
              font-size: 12px;
              color: #999;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
    .empty {
      height: 70px;
    }
    .book-list {
      margin-bottom: 40px;
      .card {
        width: 46%;
        margin-bottom: 20px;
        p {
          text-align: center;
          margin: 10px;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .footer {
      position: fixed;
      bottom: 0;
      background: #fff;
      box-shadow: 0 0 6px 2px rgba($color: #d2d2d2, $alpha: 0.38);
      color: #999;
      font-size: 12px;
      max-width: 500px;
      width: 100%;
      a {
        color: #999;
      }
    }
  }
}
</style>